import template from './tableGridIconCell.html';
import controller from './tableGridIconCell.controller';
import _ from 'lodash';

let tableGridIconCellComponent = () => {
  return {
    restrict: 'E',
    replace: false,
    scope: {
      row: '=',
      columnName: '@',
      columns: '=',
    },
    template,
    controller,
    controllerAs: 'vm',
    link: (scope, elem, attrs, ctrl) => {
      scope.column = _.find(scope.columns, {
        name: scope.columnName
      });
      scope.vm = scope;
      scope.vm.icon = ctrl.getIcon(scope.row, scope.column);
    }
  };
};

export
default tableGridIconCellComponent;


// WEBPACK FOOTER //
// ./app/components/tableGridIconCell/tableGridIconCell.component.js